export const INIT_RESOLUTIONS = 'INIT_RESOLUTIONS'
export const SET_FIRST_PLAY = 'SET_FIRST_PLAY'
export const SET_METADATA = 'SET_METADATA'
export const SET_BITRATE = 'SET_RESOLUTION'
export const TOGGLE_SETTINGS = 'TOGGLE_SETTINGS'
export const UPDATE_TIME = 'UPDATE_TIME'
export const UPDATE_VIDEO_PLAYER_STATUS = 'UPDATE_VIDEO_PLAYER_STATUS'
export const TRIAL_EXTEND = 'TRIAL_EXTEND'

export const AUTO_BITRATE = -1

export const initialState = {
  currentBitrate: AUTO_BITRATE, // placeholder
  meta: null,
  playStarted: false,
  resolutions: [],
  showSettings: false,
  time: 0,
  playerSatus: null,
  trialExtend: false
}

export const initializeState = (state) => {
  const currentBitrate =
    JSON.parse(window.localStorage.getItem('video-bitrate')) || AUTO_BITRATE
  return {
    ...state,
    currentBitrate
  }
}

const reducer = (state, action) => {
  switch (action.type) {
    case INIT_RESOLUTIONS: {
      return {
        ...state,
        resolutions: action.payload
      }
    }
    case SET_FIRST_PLAY: {
      return {
        ...state,
        playStarted: true
      }
    }
    case SET_METADATA: {
      return {
        ...state,
        meta: action.payload
      }
    }
    case SET_BITRATE: {
      return {
        ...state,
        currentBitrate: action.payload
      }
    }
    case TOGGLE_SETTINGS: {
      const currVal = state.showSettings
      return {
        ...state,
        showSettings: !currVal
      }
    }
    case UPDATE_TIME: {
      return {
        ...state,
        time: action.payload
      }
    }
    case UPDATE_VIDEO_PLAYER_STATUS: {
      return {
        ...state,
        playerSatus: action.payload
      }
    }
    case TRIAL_EXTEND: {
      return {
        ...state,
        trialExtend: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
